import { AirbnbLogo, BookingLogo, VrboLogo, TripadvisorLogo } from "./BrandLogos";

const PARTNERS = [
  { name: "Airbnb", Logo: AirbnbLogo, label: "Airbnb" },
  { name: "Booking.com", Logo: BookingLogo, label: "Booking.com" },
  { name: "Vrbo", Logo: VrboLogo, label: "Vrbo" },
  { name: "Tripadvisor", Logo: TripadvisorLogo, label: "Tripadvisor" },
];

const Partners = () => {
  return (
    <section className="py-20 lg:py-24 bg-white border-y border-ink/5" data-testid="partners-section">
      <div className="container-tm">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="overline">Plateformes partenaires</span>
          <h2 className="mt-5 font-serif font-light text-ink text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
            Diffusion sur
            <span className="italic text-gold"> les plus grandes plateformes</span>.
          </h2>
          <p className="mt-5 font-sans text-base text-ink/60 leading-relaxed">
            Nous publions et synchronisons votre annonce sur les canaux les plus performants pour maximiser votre taux d'occupation.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
          {PARTNERS.map(({ name, Logo, label }) => (
            <div
              key={name}
              data-testid={`partner-${name.toLowerCase()}`}
              className="group bg-cream/40 hover:bg-white border border-ink/10 rounded-2xl px-6 py-10 flex flex-col items-center justify-center gap-4 transition-all duration-500 hover:shadow-lift"
            >
              <div className="h-10 flex items-center justify-center opacity-90 group-hover:opacity-100 group-hover:scale-[1.06] transition-all duration-500">
                <Logo className="h-9 w-auto max-w-[140px] object-contain" />
              </div>
              <span className="text-[11px] font-sans uppercase tracking-[0.22em] font-semibold text-ink/55">
                {label}
              </span>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-xs font-sans text-ink/45 tracking-wide">
          Marques citées à titre informatif. TERRE ET MER CONCIERGERIE n'est pas affiliée à ces plateformes.
        </p>
      </div>
    </section>
  );
};

export default Partners;
